import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import Dialog from './dialog';
import 'next/stylesheets/components/hyperlink-field-value-form-dialog.scss';

Component('tr-hyperlink-field-value-form-dialog', {
  extends: [Dialog],

  properties: {
    values: {
      type: Array,
      default: [],
    },
  },

  connected() {
    this.form = this.querySelector('form');
    this.newItemLink = this.querySelector('.link-new-item');
    this.itemTemplate = this.querySelector('.tpl-hyperlink-field-value-item');

    if (!this.values || this.values.length === 0) {
      this.addNewItem();
    } else {
      this.renderItems(this.values);
    }

    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tao:closed': this.handleDialogClosed.bind(this),
    });

    this.listenTo(this.form, 'submit', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  },

  addNewItem() {
    const items = this.querySelector('.hyperlink-field-value-items');
    const item = document
      .importNode(this.itemTemplate.content, true).firstElementChild;

    let itemIndex = 0;
    const lastItem = [
      ...items.querySelectorAll('.hyperlink-field-value-item'),
    ].pop();
    if (lastItem) {
      const [, lastItemIndex] = lastItem
        .querySelector('.hyperlink-field-value-name input')
        .name.match(/\[(\d+)\]/);
      itemIndex = parseInt(lastItemIndex, 10) + 1;
    }

    [...item.querySelectorAll('input')].forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.name = input.name
        .replace(/\[(_new_value_)\]/g, () => `[${itemIndex}]`);
    });
    items.appendChild(item);

    return item;
  },

  renderItems(values) {
    values.forEach(({ name, link }) => {
      const item = this.addNewItem();
      item.querySelector('.hyperlink-field-value-name input').value = name;
      item.querySelector('.hyperlink-field-value-link input').value = link;
    });
  },

  handleClick(event) {
    if (closest(event.target, '.link-new-item', this)) {
      this.addNewItem();
    } else if (closest(event.target, '.link-remove-item', this)) {
      const item = closest(event.target, '.hyperlink-field-value-item', this);
      if (item) item.parentNode.removeChild(item);
    }
  },

  handleDialogClosed(event) {
    const action = event.detail;
    if (action === 'yes') {
      this.namespacedTrigger('submit', {
        detail: {
          values: Object.values(
            $(this.form).serializeObject().hyperlink_field_value,
          ),
        },
      });
    }
  },
});
